import axios from 'axios';
import IMask from 'imask';
export default class Calculator {
    constructor() {
        this.form = document.querySelector('#calculadoraDeProteinas');
        this.steps = document.querySelectorAll('.step');
        this.btnSteps = this.form.querySelectorAll('.btn-step');

        this.fieldAge = document.querySelector('#age');
        this.fieldHeight = document.querySelector('#height');
        this.fieldWeight = document.querySelector('#weight');

        this.identifyField = document.querySelector('#idenfity');
        this.genderField = document.querySelector('.genderField');

        this.bgLast = document.querySelector('.bgLast');

        this.email = this.form.querySelector('#email');
        this.politica = this.form.querySelector('#optin');
        this.maiorIdade = this.form.querySelector('#maiorIdade');

        this.btnCalculate = this.form.querySelector('#btnStep7');
        this.btnCalculateNoEmail = this.form.querySelector('#btnStep7NoEmail');

        if (localStorage.getItem('Calculadora') != null) {
            this.getDataFromLocalStorage();
        }

        this.ready();
    }

    ready() {
        if (this.fieldWeight) {
            let weightMask = IMask(this.fieldWeight, {
                mask: Number,
                scale: 2,
                thousandsSeparator: '',
                padFractionalZeros: false,
                normalizeZeros: true,
                radix: ',',
                mapToRadix: ['.'],
            });
        }

        if (this.identifyField) {
            this.identifyField.addEventListener('change', () => {
                if (this.identifyField.value === 'Outro (qual?)') {
                    this.genderField?.classList.remove('hidden');
                } else {
                    this.genderField?.classList.add('hidden');
                }
            });
        }

        if (this.fieldAge) {
            this.fieldAge.addEventListener('keyup', () => {
                this.fieldAge.value = this.fieldAge.value.replace(/[^0-9]/g, '');
            });
        }

        if (this.fieldHeight) {
            this.fieldHeight.addEventListener('keyup', () => {
                this.fieldHeight.value = this.fieldHeight.value.replace(/[^0-9]/g, '');
            });
        }

        if (!this.btnSteps?.length) {
            return;
        }

        this.btnSteps.forEach((btn) => {
            btn.addEventListener('click', () => {
                let nextStep = btn.dataset.nextstep;
                const step = +nextStep - 1;

                let erros = 0;

                if (step === 1) {
                    if (this.form.querySelector('#name').value === '') {
                        this.form.querySelector('#name').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#name').classList.remove('border-red-500');
                    }
                } else if (step === 2) {
                    if (this.form.querySelector('#age').value === '') {
                        this.form.querySelector('#age').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#age').classList.remove('border-red-500');
                    }
                    if (this.identifyField.value === '0') {
                        this.identifyField.classList.add('border-red-500');
                        erros++;
                    } else {
                        this.identifyField.classList.remove('border-red-500');
                    }
                    if (this.identifyField.value === 'Outro (qual?)') {
                        if (this.genderField.querySelector('#gender').value === '') {
                            this.genderField.querySelector('#gender').classList.add('border-red-500');
                            erros++;
                        } else {
                            this.genderField.querySelector('#gender').classList.remove('border-red-500');
                        }
                    }
                    if (this.form.querySelector('#height').value === '') {
                        this.form.querySelector('#height').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#height').classList.remove('border-red-500');
                    }
                    if (this.form.querySelector('#weight').value === '') {
                        this.form.querySelector('#weight').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#weight').classList.remove('border-red-500');
                    }
                } else if (step === 3) {
                    if (this.form.querySelector('#activity').value === '0') {
                        this.form.querySelector('#activity').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#activity').classList.remove('border-red-500');
                    }

                    const optionTypesToHidden = this.form.querySelector('#type');
                    if (this.form.querySelector('#activity').value === '2') {
                        optionTypesToHidden.querySelector("option[value='0']").style.display = 'none';
                    } else {
                        optionTypesToHidden.querySelector("option[value='0']").style.display = 'initial';
                    }

                    // Sedentário: pula treinos (step 4) e vai para Objetivo (step 5)
                    if (this.form.querySelector('#activity').value === '1') {
                        nextStep++;
                    }
                } else if (step === 4) {
                    if (this.form.querySelector('#frequency').value === '') {
                        this.form.querySelector('#frequency').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#frequency').classList.remove('border-red-500');
                    }
                    if (this.form.querySelector('#duration').value === '') {
                        this.form.querySelector('#duration').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#duration').classList.remove('border-red-500');
                    }
                    if (this.form.querySelector('#type').value === '') {
                        this.form.querySelector('#type').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#type').classList.remove('border-red-500');
                    }
                    if (this.form.querySelector('#goal').value === '0') {
                        this.form.querySelector('#goal').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#goal').classList.remove('border-red-500');
                    }
                } else if (step === 5) {
                    if (this.form.querySelector('#body_goal').value === '0') {
                        this.form.querySelector('#body_goal').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#body_goal').classList.remove('border-red-500');
                    }
                } else if (step === 6) {
                    if (this.form.querySelector('#diet').value === '0') {
                        this.form.querySelector('#diet').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#diet').classList.remove('border-red-500');
                    }
                    if (this.form.querySelector('#flavor').value === '0') {
                        this.form.querySelector('#flavor').classList.add('border-red-500');
                        erros++;
                    } else {
                        this.form.querySelector('#flavor').classList.remove('border-red-500');
                    }
                }

                if (erros === 0) {
                    if (+nextStep === 6 && this.bgLast) {
                        this.bgLast.classList.add('opacity-100');
                    }

                    const nextStepEl = document.querySelector('#step' + nextStep);
                    if (nextStepEl) {
                        nextStepEl.classList.add('active');
                        nextStepEl.scrollIntoView();
                    }
                }
            });
        });

        if (this.btnCalculate) {
            this.btnCalculate.addEventListener('click', () => {
                let erros = 0;

                if (this.email.value === '') {
                    this.email.classList.add('border-red-500');
                    erros++;
                } else {
                    this.email.classList.remove('border-red-500');
                }

                if (this.maiorIdade.checked) {
                    this.maiorIdade.classList.remove('border-red-500');
                } else {
                    this.maiorIdade.classList.add('border-red-500');
                    erros++;
                }

                if (erros === 0) {
                    this.sendRD();
                }
            });
        }

        if (this.btnCalculateNoEmail) {
            this.btnCalculateNoEmail.addEventListener('click', () => {
                let erros = 0;

                if (this.maiorIdade.checked) {
                    this.maiorIdade.classList.remove('border-red-500');
                } else {
                    this.maiorIdade.classList.add('border-red-500');
                    erros++;
                }

                if (erros === 0) {
                    this.saveDataToLocalStorage();
                }
            });
        }
    }

    saveDataToLocalStorage() {
        const obj = {};
        const formData = new FormData(this.form);
        for (let key of formData.keys()) {
            obj[key] = formData.get(key);
        }
        const json = JSON.stringify(obj);
        localStorage.setItem('Calculadora', json);
        this.form.submit();
    }

    getDataFromLocalStorage() {
        const data = JSON.parse(localStorage.getItem('Calculadora'));
        Object.entries(data).forEach((entry) => {
            const [key, value] = entry;
            const element = this.form.querySelector(`#${key}`);
            if (element) {
                element.value = value;
            }
        });
    }

    sendRD() {
        this.btnCalculate.disabled = true;
        const obj = {};
        const formData = new FormData(this.form);
        for (let key of formData.keys()) {
            obj[key] = formData.get(key);
        }
        const json = JSON.stringify(obj);
        localStorage.setItem('Calculadora', json);

        axios({
            url: 'https://api.rd.services/platform/conversions?api_key=0979f1033464ec31891b1e32f9d09094',
            method: 'POST',
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({
                event_type: 'CONVERSION',
                event_family: 'CDP',
                payload: {
                    conversion_identifier: 'formCalculadora',
                    nome: formData.get('name'),
                    email: formData.get('email'),
                },
            }),
        })
            .then(() => {
                this.form.submit();
            })
            .catch(() => {
                console.log('Erro');
                this.form.submit();
            });
    }
}
if (document.querySelector('.component-calculator')) {
    new Calculator();
}
